class Customer.TicketSummary extends Backbone.Model
  initialize: (attributes, tags) ->
    super attributes
    @tags = tags

  toggleSelect: (checked) ->
    @set('selected', checked, silent: true)
    @trigger('ticket:summary:selected', checked)

  isInstagram: ->
    !!@get('instagram_summary')

  isInstagramMessageUnsupported: ->
    typeof @get('instagram_summary')?.is_keepcon_unsupported == 'boolean'

  isKeepconUnsupported: ->
    @get('instagram_summary').is_keepcon_unsupported

  areInstagramStoriesExpired: ->
    @get('instagram_summary')?.stories_are_expired

  instagramStories: ->
    attachments = @get('instagram_summary').instagram_stories
    _.flatten([@_getAttachments(attachments, type)] for type in ['image', 'video']) if attachments

  instagramAttachments: ->
    attachments = @get('instagram_summary').instagram_attachments
    return unless attachments
    _.object(["#{type}s", @_getAttachments(attachments, type)] for type in ['image', 'video', 'audio', 'file'])

  authorUsername: ->
    @get('author_username')

  authorName: ->
    if ['ig-user', 'ig-message'].includes(@get('sub_type')) then @authorUsername() else @get('author_name')

  _getAttachments: (attachments, type) ->
    _.select(attachments, (attachment) -> attachment.type == type)
